import { render } from "./createCostTypeDialog.vue?vue&type=template&id=6e5a2958&scoped=true"
import script from "./createCostTypeDialog.vue?vue&type=script&lang=js"
export * from "./createCostTypeDialog.vue?vue&type=script&lang=js"

import "./createCostTypeDialog.vue?vue&type=style&index=0&id=6e5a2958&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5a2958"]])

export default __exports__